export default __webpack_public_path__ + "static/WheresMike_print_11x17-063bff4a5c8976d282eb46585c670227.pdf";